/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { ReactNode, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSchedule } from '../_features/ScheduleContext'
import { useMyself } from '../_features/UserContext'
import { classNames } from '../_helpers'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { SlideOver } from './SlideOver'

export const Layout = ({ children }: { children: ReactNode }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { isDebugUser } = useMyself() || {}
  const { season } = useSchedule() || {}

  const location = useLocation()

  useEffect(() => {
    setMobileMenuOpen(false)
  }, [location])

  const isStaging = useMemo(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)

    if (urlParams.get('banner') === 'true') {
      return true
    }

    return window.location.host.includes('staging.beckenrocker')
      && urlParams.get('banner') !== 'false'
  }, [])

  const isSwitchedSeason = useMemo(() => {
    return season && !season.isLatest
  }, [season])

  return (
    <>
      <div className={classNames(
        'flex h-full',
        (isStaging || isDebugUser || isSwitchedSeason) ? 'pt-7' : ''
      )}>
        {isStaging && (
          <div className={'fixed flex top-0 left-0 w-screen h-7 bg-red-600 items-center justify-center uppercase font-bold text-white tracking-widest'}>
            Test-system
          </div>
        )}
        {isDebugUser && (
          <div className={'fixed flex top-0 left-0 w-screen h-7 bg-red-600 items-center justify-center uppercase font-bold text-white tracking-widest'}>
            <div className="relative flex w-full items-center justify-center">
              <span>DEBUG-USER</span>
              <button
                type="button"
                onClick={() => {
                  localStorage.removeItem('debug-user-id')
                  window.location.reload()
                }}
                className="absolute right-2 flex h-5 w-5 items-center justify-center rounded-full text-white hover:bg-white/20 focus:outline-none focus:ring-0"
                aria-label="Benutzerwechsel zurücksetzen"
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}
        {isSwitchedSeason && (
          <div className={'fixed flex gap-4 top-0 left-0 w-screen h-7 bg-yellow-400 items-center justify-center uppercase font-bold text-white tracking-widest'}>
            <ExclamationTriangleIcon className={'w-5 h-5'} />
            {season?.title}
            <ExclamationTriangleIcon className={'w-5 h-5'} />
          </div>
        )}
        {/* Narrow sidebar */}
        <Sidebar
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Content area */}
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header setMobileMenuOpen={setMobileMenuOpen} />

          {/* Main content */}
          <div className="flex flex-1 items-stretch overflow-hidden lg:pb-0">
            {children}
          </div>
        </div>
      </div>

      <SlideOver />
    </>
  )
}
